import { I18n } from '@calendly/i18n';
import { PhoneNumberWithFlagNoSuspense as PhoneNumberWithFlag } from '@calendly/telephone-tools';
import { TitleText } from '@calendly/ui/components/typography';
import { SelectField } from '@calendly/ui/form/select-field';
import classNames from 'classnames';
import { useCallback, useEffect, useState, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useGetUserProfile } from 'common';
import { phoneNumbersSelector, primaryPhoneNumberSelector, primaryPhoneNumberStatusSelector, setPrimaryPhoneNumber } from 'features/phone_numbers';
import { ConfirmationPopup } from './confirmation_popup';
const headerBlockCss = "hzi3q4o";
const HeaderBlock = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(headerBlockCss, props.className)} />;
});
const Text = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={props.className} />;
});
const popupTextCss = "p1wpyjj0";
const PopupText = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(popupTextCss, props.className)} />;
});
export const PrimaryPhoneNumber = () => {
  const dispatch = useDispatch();
  const {
    owner_id: ownerId
  } = useGetUserProfile();
  const phoneNumbers = useSelector(phoneNumbersSelector);
  const primaryPhoneNumberStatus = useSelector(primaryPhoneNumberStatusSelector);
  const {
    uuid: primaryPhoneNumberUuid
  } = useSelector(primaryPhoneNumberSelector) || {};
  const [selectedPrimaryUuid, setSelectedPrimaryUuid] = useState(null);
  const onCloseModal = useCallback(() => {
    setSelectedPrimaryUuid(null);
  }, []);
  useEffect(() => {
    if (primaryPhoneNumberStatus === 'ready') {
      onCloseModal();
    }
  }, [dispatch, onCloseModal, primaryPhoneNumberStatus]);
  const onConfirm = () => {
    dispatch(setPrimaryPhoneNumber({
      userId: ownerId,
      phoneNumberUuid: selectedPrimaryUuid
    }));
  };
  if (phoneNumbers.length <= 1) return null;
  const options = phoneNumbers.map(({
    e164_phone_number: number,
    uuid
  }) => ({
    id: uuid,
    name: <PhoneNumberWithFlag phoneNumber={number} />
  }));
  const isPopupOpen = selectedPrimaryUuid && selectedPrimaryUuid !== primaryPhoneNumberUuid;
  return <>
      <HeaderBlock>
        <TitleText id="selectTitle" size="small">
          {I18n.t('publisher.account_settings.phone_numbers.primary.title')}
        </TitleText>
        <Text>{I18n.t('publisher.account_settings.phone_numbers.primary.text')}</Text>
      </HeaderBlock>
      <SelectField aria-labelledby="selectTitle" options={options} onChange={setSelectedPrimaryUuid} value={primaryPhoneNumberUuid} />
      <ConfirmationPopup onClose={onCloseModal} title={I18n.t('publisher.account_settings.phone_numbers.primary.popup.title')} confirmLabel={I18n.t('publisher.account_settings.phone_numbers.primary.popup.confirm')} onConfirm={onConfirm} isOpen={isPopupOpen} isLoading={primaryPhoneNumberStatus === 'requesting'}>
        <PopupText>
          {I18n.t('publisher.account_settings.phone_numbers.primary.popup.text')}
        </PopupText>
      </ConfirmationPopup>
    </>;
};

require("./primary_phone_number.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./primary_phone_number.js");